import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import Login from "../views/login.vue";
import Store from "../views/store.vue";
import Signup from "../views/signup.vue";
import Userhome from "../views/userhome.vue";
import Forgotpassword from "../views/forgotpassword.vue";
import Changepassword from "../views/changepassword.vue";
import Redeemcode from "../views/redeemcode.vue";
import Battlereport from "../views/battlereport.vue";
import Directstore from "../views/directstore.vue";
import Purchasecomplete from "../views/purchasecomplete.vue";
import VerifyDevice from "../views/verifyDevice.vue";
import Paypal from "../views/paypal.vue";
import subscriptioncomplete from "../views/subscriptioncomplete.vue";
import subscriptioncancel from "../views/subscriptioncancel.vue";

Vue.use(VueRouter);

// eslint-disable-next-line prettier-vue/prettier
const routes = [
  {
    path: "/",
    name: "login",
    component: Login,
  },
  {
    path: "/store",
    name: "store",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Store,
  },
  {
    path: "/signup",
    name: "signup",
    component: Signup,
  },
  {
    path: "/forgotpassword",
    name: "forgotpassword",
    component: Forgotpassword,
  },
  {
    path: "/userhome",
    name: "userhome",
    component: Userhome,
  },
  {
    path: "/changepassword",
    name: "changepassword",
    component: Changepassword,
  },
  {
    path: "/battlereport",
    name: "battlereport",
    component: Battlereport,
    props: true
  },
  {
    path: "/redeemcode",
    name: "redeemcode",
    component: Redeemcode,
  },
  {
    path: "/directstore",
    name: "directstore",
    component: Directstore,
  },
  {
    path: "/purchaseComplete",
    name: "purchasecomplete",
    component: Purchasecomplete,
  },
  {
    path: "/verifyDevice",
    name: "verifyDevice",
    component: VerifyDevice,
  },
  {
    path: "/paypal",
    name: "paypal",
    component: Paypal,
  },
  {
    path: "/subscriptioncomplete",
    name: "subscriptioncomplete",
    component: subscriptioncomplete,
  },
  {
    path: "/subscriptioncancel",
    name: "subscriptioncancel",
    component: subscriptioncancel,
  },
  {
    path: '/wds3-editor',
    name: 'WDS3DataEditor',
    component: () => import('@/views/WDS3DataEditor.vue')
  },
  {
    path: '/editor2/:gameName/:factionName',
    name: 'WDS2UnitEditor',
    component: () => import('@/views/WDS2UnitEditor.vue'),
    props: true,
  },
  {
    path: '/ModelCreator',
    name: 'ModelCreator',
    component: () => import('@/views/ModelCreator.vue'),
    beforeEnter: async (to, from, next) => {
      // store.state.userid is populated asynchronously by App.vue, so we verify
      // the session cookie directly instead of relying on the store.
      if (store.state.userid) {
        next();
        return;
      }
      try {
        const res = await fetch('/retrieveToken', {
          method: 'GET',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          credentials: 'include',
        });
        const claim = await res.json();
        if (claim && claim.user_id) {
          next();
        } else {
          next({ name: 'login', query: { redirect: '/ModelCreator' } });
        }
      } catch {
        next({ name: 'login', query: { redirect: '/ModelCreator' } });
      }
    },
  },
  {
    path: '/AddNewGame',
    name: 'AddNewGame',
    component: () => import('@/views/AddNewGame.vue'),
    beforeEnter: async (to, from, next) => {
      if (store.state.userid) {
        next();
        return;
      }
      try {
        const res = await fetch('/retrieveToken', {
          method: 'GET',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          credentials: 'include',
        });
        const claim = await res.json();
        if (claim && claim.user_id) {
          next();
        } else {
          next({ name: 'login', query: { redirect: '/AddNewGame' } });
        }
      } catch {
        next({ name: 'login', query: { redirect: '/AddNewGame' } });
      }
    },
  },
  {
    path: '/ModifyGame',
    name: 'ModifyGame',
    component: () => import('@/views/ModifyGame.vue'),
    beforeEnter: async (to, from, next) => {
      if (store.state.userid) {
        next();
        return;
      }
      try {
        const res = await fetch('/retrieveToken', {
          method: 'GET',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          credentials: 'include',
        });
        const claim = await res.json();
        if (claim && claim.user_id) {
          next();
        } else {
          next({ name: 'login', query: { redirect: '/ModifyGame' } });
        }
      } catch {
        next({ name: 'login', query: { redirect: '/ModifyGame' } });
      }
    },
  },
  {
    path: '/Catalogue',
    name: 'catalogue',
    component: () => import('@/views/Catalogue.vue'),
  },
  {
    path: '/creator',
    name: 'CreatorLanding',
    component: () => import('@/views/CreatorLanding.vue'),
  },
  {
    path: '/join-game',
    name: 'JoinGame',
    component: () => import('@/views/JoinGame.vue'),
    beforeEnter: async (to, from, next) => {
      if (store.state.userid) {
        next();
        return;
      }
      try {
        const res = await fetch('/retrieveToken', {
          method: 'GET',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          credentials: 'include',
        });
        const claim = await res.json();
        if (claim && claim.user_id) {
          next();
        } else {
          next({ name: 'login', query: { redirect: '/join-game' } });
        }
      } catch {
        next({ name: 'login', query: { redirect: '/join-game' } });
      }
    },
  },
];const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
